import React, { type ReactNode, useContext } from 'react';

import { AnimatePresence } from 'framer-motion';
import { ThemeContext } from 'styled-components';

import { useAppDispatch, useAppSelector } from '@pkg/hooks';

import { toggleDisplaySnackbar } from '@app/store/actions/nft-manager';

import { SnackbarWrapper } from './styles';

export interface SnackbarProps {
    children?: ReactNode;
}

export function Snackbar({ children }: SnackbarProps) {
    const theme = useContext(ThemeContext);
    const dispatch = useAppDispatch();
    const displaySnackbar = useAppSelector((state) => state.nftManager.displaySnackbar);

    return (
        <AnimatePresence mode="wait">
            {displaySnackbar && (
                <SnackbarWrapper
                    initial={{ opacity: 0, y: 120 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 120 }}
                    transition={{
                        duration: theme.transitions.speeds.fast,
                        ease: theme.transitions.eases.cubic,
                    }}
                    onClick={() => dispatch(toggleDisplaySnackbar(false, false))}
                >
                    {children}
                </SnackbarWrapper>
            )}
        </AnimatePresence>
    );
}
